import { render } from "./ReasonsToUse.vue?vue&type=template&id=1f9d1400&scoped=true&ts=true"
import script from "./ReasonsToUse.vue?vue&type=script&lang=ts"
export * from "./ReasonsToUse.vue?vue&type=script&lang=ts"

import "./ReasonsToUse.vue?vue&type=style&index=0&id=1f9d1400&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/range-compose-campaign-ui_master/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f9d1400"]])

export default __exports__